let $ = require('jquery');

if ($('#car-loan-calculator').length) {
    let calculateCarLoan = function () {
        let loanDuration = $('[name="loan_duration"]').val();
        let loanAmount = $('[name="loan_amount"]').val();
        let downPayment = $('[name="down_payment"]').val();
        let creditScore = $('[name="credit_score"]:checked').val();
        let multiplier = 0;

        if (creditScore === 'Poor') {
            multiplier = 1.1985;
        }
        else if (creditScore === 'Average') {
            multiplier = 1.1290;
        }
        else if (creditScore === 'Good') {
            multiplier = 1.0700;
        }
        else if (creditScore === 'Excellent') {
            multiplier = 1.0352;
        }

        let total = ((loanAmount - downPayment) * multiplier) / loanDuration;

        $('#monthly-payment').html('$' + Math.round(total));
        $('#weekly-payment').html('$' + Math.round(total / 4));
        $('#biweekly-payment').html('$' + Math.round(total / 2));
    };

    $('[name="loan_duration"], [name="loan_amount"], [name="down_payment"], [name="credit_score"]')
        .on('keyup change', function () {
            calculateCarLoan();
        });

    calculateCarLoan();
}
